import React from 'react';

export default class Page6 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToSupportAndChallengeInTandem');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">

                                            <div className="circle_title-first">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">Further Information</span>
                                            </div>
                                            <div className="paraspace"><p>If you found this tool useful, then
                                                you are likely to find the following tools both insightful and
                                                relevant:</p></div>
                                            <div className="keyquestionpad">
                                                <ul className="greenbullet-list sept">
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToBeAssertive')}>How
                                                        to be assertive</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToManageYourImpact')}>How
                                                        to manage your impact</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToManageDifficultConversations')}>How
                                                        to manage difficult conversations</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToDevelopOthers')}>How
                                                        to develop others</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToChallengeOthersEffectively')}>How
                                                        to challenge others effectively</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToEngageOthersToDeliver')}>How
                                                        to engage others to deliver.</div></li>
                                                </ul>
                                            </div>
                                            <div className="circle_title "><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>REFERENCES
                                            </div>

                                            <ol className="testclass">
                                                <li><p className="further_info_content">Roberts, K.
                                                    C., &amp; Danoff-Burg, S. (2010). Mindfulness and health
                                                    behaviors: is paying attention good for you?. <span
                                                        className="subtiltereg">Journal of American College Health,</span> 59(3),
                                                    165-173.</p></li>

                                                <li><p className="further_info_content">Robertson, I. T.,
                                                    Cooper, G. L., &amp; Williams, J. (1990). The validity of
                                                    the Occupational Stress Indicator.<span
                                                        className="subtiltereg"> Work &amp; Stress,</span> 4:
                                                    29-39.</p></li>
                                                <li><p className="further_info_content"> J. Arnold, I.T.
                                                    Robertson and C.L. Cooper (1991).<span
                                                        className="subtiltereg"> Work psychology: Understanding human behaviour in the workplace,</span> United
                                                    Kingdom: Longman.</p></li>

                                            </ol>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this._savePageStatus('People')}
                                                    className="button-next-previous-done">Done
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}